import { addDomEvent } from "./add-dom-event";
import { addPointerInfo } from "./event-info";
export function addPointerEvent(target, eventName, handler, options) {
    return addDomEvent(target, eventName, addPointerInfo(handler), options);
}
//# sourceMappingURL=add-pointer-event.js.map